var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22949 13.1392H17.1717V27.0813H13.4538V19.4866L6.80216 26.1382L4.1732 23.5092L10.8254 16.8571H3.22949V13.1392Z",
    fill: "#1C1D22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4542 2.91895H17.1722V10.5154L23.8256 3.86204L26.4545 6.491L19.8023 13.1432H27.3964V16.8611H19.7872L26.4697 23.5436L23.8407 26.1725L18.5606 20.8925V11.7088H9.377L4.15918 6.491L6.78814 3.86204L13.4542 10.5281V2.91895Z",
    fill: "#E6007E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoomIcon);
export default __webpack_public_path__ + "static/media/boomIcon.292cb39bf988e3027e749e6c4466e9c7.svg";
export { ForwardRef as ReactComponent };